export default [
    {
        id: 1,
        title: "Uber",
        coverImg: "uber.webp",
        route: "uber",

    },
    {
        id: 2,
        title: "Uber Eats",
        coverImg: "ubereats.webp",
        route: "ubereats",
    },
    {
        id: 3,
        title: "Lyft",
        coverImg: "lyft.webp",
        route: "lyft",
    },
    {
        id: 4,
        title: "Door Dash",
        coverImg: "doordash.webp",
        route: "doordash",
    },
    {
        id: 5,
        title: "Amazon",
        coverImg: "amazon.webp",
        route: "amazon",
    },
    {
        id: 6,
        title: "Gojek",
        coverImg: "gojek.webp",
        route: "gojek",
    },
    {
        id: 7,
        title: "Grab",
        coverImg: "grab.webp",
        route: "grab",
    }
    ,
    {
        id: 8,
        title: "Instacart",
        coverImg: "instacart.webp",
        route: "instacart",
    }
    ,
    {
        id: 9,
        title: "Wolt",
        coverImg: "wolt.webp",
        route: "wolt",
    }
]